// extracted by mini-css-extract-plugin
module.exports = {"BigHeading":"Heading_BigHeading__DJMzT","MediumHeading":"Heading_MediumHeading__2Tg6u","NumberedHeading":"Heading_NumberedHeading__3ZpRg"};